import { useState } from "react";
import { useForm } from "react-hook-form";
export var useCreateRol = function () {
    var _a = useState(false), openDrawer = _a[0], setOpenDrawer = _a[1];
    var useFormRol = useForm();
    return { openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, useFormRol: useFormRol };
};
